import { useTranslate } from 'ra-core'

const DealTitle = ({ record }: { record?: { title?: string }; translate?: unknown; style?: React.CSSProperties }) => {
  const translate = useTranslate()
  return (
    <span>
      {translate('Deal')} {record ? `"${record.title}"` : ''}
    </span>
  )
}

export default {
  list: { lazy: () => import('./DealList') },
  create: { lazy: () => import('./RuleCreate'), component: 'RuleCreate' },
  edit: { lazy: () => import('./RuleEdit'), component: 'RuleEdit' },
  options: {
    list: {
      title: 'Deals',
      breadCrumb: 'Deals',
    },
    create: {
      title: 'Create Deal Rule',
      breadCrumb: 'Create Deal',
    },
    edit: {
      title: <DealTitle />,
      breadCrumb: 'Edit Deal',
    },
  },
}
